import {isAnalysisTemplateGraphQL} from 'analysis-tool/AnalysisTypes';
import {getStepFromAnalysis} from 'analysis-tool/data/getStepFromAnalysis';
import {isTopLevelDataFrameView, isTopLevelFileView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {
  AnalysisRightSidebarItem,
  AnalysisRightSidebarItemType,
} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import {recordAnalysisAction} from 'analysis-tool/ui/debugAnalysisActionHistory';
import {stepIsConfigEditorSupported} from 'pipelines/generalized-step-config-editor/stepTypeIsConfigEditorSupported';
import {PipelineGraphQL, PipelineViewGraphQL} from 'pipelines/PipelineTypes';

/**
 * Action to edit the first step in a view.
 */
export default function getEditSourceStepAction(
  analysis: PipelineGraphQL,
  view: PipelineViewGraphQL,
  onChangeSelectedRightSidebarItem: (newSelectedItem: AnalysisRightSidebarItem | null) => void
): OverflowDataViewAction | null {
  /*
   * In templates, "Edit source step" is shown instead of "Replace source".
   *
   * "Replace source" is hidden in templates because it does not work with the main source types in
   * templates (DEFINE_TEMPLATE_VARIABLES, DATA_CATALOG_FILES, VARIABLE_TEMPLATE_INPUT_TABLE) and the
   * non-editable MAP_COLUMNS steps added by "Replace source" create fragile templates.
   *
   * We may make "Edit source step" available in analyses in the future.
   */
  if (!isAnalysisTemplateGraphQL(analysis)) {
    return null;
  }

  const step = getStepFromAnalysis(analysis, view.lineage[0].step.id);

  if (
    !stepIsConfigEditorSupported(step) ||
    !(isTopLevelDataFrameView(view, analysis) || isTopLevelFileView(view, analysis))
  ) {
    return null;
  }

  return {
    icon: 'edit',
    onClick: () => {
      recordAnalysisAction('EDIT_STEP', {
        analysisId: analysis.id,
        stepId: step.id,
        stepType: step.stepType,
      });
      onChangeSelectedRightSidebarItem({
        type: AnalysisRightSidebarItemType.EDIT_STEP,
        stepId: step.id,
      });
    },
    label: 'Edit source step',
  };
}
